import React from "react";
import styles from "./Button.module.css";

const Button = ({
  children,
  variant = "primary",
  onClick,
  type = "button",
  href,
  disabled,
  ...props
}) => {
  const className = `${styles.button} ${styles[variant]}`;
  if (href) {
    return (
      <a href={href} className={className} {...props}>
        {children}
      </a>
    );
  }
  return (
    <button
      type={type}
      className={className}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
